import { Collection } from 'modules/core/lib/mobx-rest'

import type Allowance from 'modules/timeoff/store/models/Allowance'
import TimeoffPolicy from 'modules/timeoff/store/models/TimeoffPolicy/Policy'

export interface AllowanceMapItem {
  oldAllowanceId: string
  newAllowanceId: string | null
}
export type BulkAssignEmployeesDto = {
  employeeIds: string[]
  mappings: AllowanceMapItem[]
  policyId: string
}


class TimeoffPolicies extends Collection<TimeoffPolicy> {
  get cacheKey(): string {
    return 'timeoffPolicies'
  }

  model() {
    return TimeoffPolicy
  }
}

const singleton: TimeoffPolicies = new TimeoffPolicies()

export const allowancePolicy = (allowance: Allowance) => {
  const timeoffPolicyId = allowance.attributes.timeoff_policy_id

  return singleton.get(timeoffPolicyId)
}
export default singleton
